import { Spinner } from '@platform/components';
import { Control } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';
import { OptionalNote } from './OptionalNote';

export const MatchedElsewhereContent = (props: {
  control: Control<UpdateDiscoveryCallFormData>;
  isSaving: boolean;
  // Pros see the standalone page with the explanatory copy; reps fill the note inline without it.
  showIntro?: boolean;
}) => {
  return (
    <div className='flex flex-col gap-4 items-center md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <Spinner />
      : <>
          {props.showIntro && (
            <>
              <div className='text-center font-semibold text-lg'>Thanks for letting us know!</div>
              <div className='text-center text-lg'>
                We'll decline this and your other pending introductions and connections on your
                behalf. You can find them in the Inactive tab under My Projects.
              </div>
            </>
          )}
          <OptionalNote control={props.control} placeholder='Enter details' />
        </>
      }
    </div>
  );
};
